const $ = require('jquery');
import run from '../../utilities/run';
import AltAddressValidation from "./viewAltAddressValidationLogic.js";
import SchedPickupDisplayLogic from "./viewSchedPickupDisplayLogic.js";

// NOTE - choose target (id or unique class) where you want this to
const targetSelector = "#schedule-pickup-target";

run(targetSelector, (outerEl)=>{
 attachViewPage(outerEl);
});

function attachViewPage(outerEl){
  const isExternal = outerEl.data('is-external');
  const availablePickupTimesContainer = outerEl.find(".available-pickup-times-container");

  $(".time-option").on("click",function() {
    const selectedTimeRow = $(this);
    const selectedCheckbox = $(this).find(".schedPickUpTimes");

    availablePickupTimesContainer.find(".time-option").removeClass("highlight-row");
    selectedTimeRow.addClass("highlight-row");

    if(!selectedCheckbox.is(":checked")){
      selectedCheckbox.prop("checked",true);
    }
  });

  const altAddressTarg = outerEl.find(".alt-address-target");

  const altAddress = new AltAddressValidation(altAddressTarg, {isExternal});
  altAddress.init();

  const schedPickupDisplay = new SchedPickupDisplayLogic(outerEl, {isExternal});
  schedPickupDisplay.init();
}



// WEBPACK FOOTER //
// ./src/pages/schedulePickup/view.js